"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PreviewConfig = /** @class */ (function () {
    function PreviewConfig(json) {
        this.json = json;
    }
    PreviewConfig.prototype.getPreview = function () {
        var previewConfig = this.json.preview;
        return {
            meta: previewConfig.meta,
            pages: this.getPages(previewConfig.pages)
        };
    };
    PreviewConfig.prototype.getPages = function (pagesConfig) {
        var _this = this;
        return pagesConfig.map(function (pageConfig) {
            return {
                id: pageConfig.id,
                zoom: pageConfig.zoom,
                width: pageConfig.width,
                height: pageConfig.height,
                type: pageConfig.type,
                condition: pageConfig.condition,
                layers: pageConfig.type === 'multi-page' ? [] : _this.getLayers(pageConfig.layers)
            };
        });
    };
    PreviewConfig.prototype.getLayers = function (layersConfig) {
        var _this = this;
        return layersConfig.map(function (layerConfig) {
            return {
                type: layerConfig.type,
                class: layerConfig.class,
                scale: layerConfig.scale,
                options: _this.getOptions(layerConfig.options)
            };
        });
    };
    PreviewConfig.prototype.getOptions = function (optionsConfig) {
        return optionsConfig.map(function (optionConfig) {
            var option = {
                value: optionConfig.value,
                class: optionConfig.class,
                group: optionConfig.group,
                form: optionConfig.form
            };
            if (optionConfig.condition === undefined) {
                option.condition = true;
            }
            else {
                option.$condition = optionConfig.condition;
            }
            return option;
        });
    };
    return PreviewConfig;
}());
exports.default = PreviewConfig;
